if (!customElements.get('load-more-button')) {
  customElements.define(
    'load-more-button',
    class LoadMoreButton extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.button.addEventListener('click', this.loadMore.bind(this));
        const container = this.closest('#ProductGridContainer');
        const pagination = container && container.querySelector('.pagination-wrapper');
        if (pagination) pagination.classList.add('hidden');
      }

      get gridId() {
        return this.dataset.gridId || 'product-grid';
      }

      async loadMore() {
        const url = this.dataset.nextUrl;
        if (!url || this.loading) return;
        this.setLoading(true);
        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error('HTTP ' + response.status);
          const text = await response.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const grid = document.getElementById(this.gridId);
          const newGrid = doc.getElementById(this.gridId);
          if (!grid || !newGrid) throw new Error('grid not found');
          Array.from(newGrid.children).forEach((item) => {
            item.classList.remove('scroll-trigger', 'animate--slide-in');
            item.removeAttribute('data-cascade');
            grid.appendChild(item);
          });
          const nextButton =
            doc.querySelector('load-more-button[data-grid-id="' + this.gridId + '"]') ||
            doc.querySelector('load-more-button');
          if (nextButton && nextButton.dataset.nextUrl) {
            this.dataset.nextUrl = nextButton.dataset.nextUrl;
            this.setLoading(false);
          } else {
            this.remove();
          }
        } catch (error) {
          window.location.href = url;
        }
      }

      setLoading(loading) {
        this.loading = loading;
        this.button.setAttribute('aria-disabled', loading ? 'true' : 'false');
        const label = this.querySelector('.load-more__label');
        if (label) label.textContent = loading ? this.dataset.loadingText : this.dataset.labelText;
      }
    }
  );
}
